// this function handles all form submissions
export class SubmitForm {
  static async editProfileFrom(values: any, cb: Function) {
    console.log(values);
    cb();
  }
  static async createChannelForm(values: any, cb: Function) {
    console.log(values);
    cb();
  }
  static async loginForm(values: any, cb: Function) {
    console.log(values);
    cb();
  }
  static async signUpForm(values: any, cb: Function) {
    console.log(values);
    cb();
  }
}
